import o,{keyframes as a,css as t}from"../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as i}from"../../theme/index.js";const n=i["theme"],r=a`
  from {
    transform: translate3d(-50%, 100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(-50%, -50%, 0);
    opacity: 1;
  }
  `,s=a`
  from {
    transform: translate3d(-50%, -50%, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(-50%, 100%, 0);
    opacity: 0;
  }
`,e=o.div`
  position: fixed;
  z-index: ${n.zIndex.modal};
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 290px;
  padding: 16px;
  background-color: ${n.colorVariables.bgPrimary};
  border-radius: ${n.borderRadiusVariables.main};
  box-shadow: ${n.shadowVariables.componentContainer};
  animation-fill-mode: forwards;

  ${({withAnimation:o,animationDuration:a})=>o&&t`
        animation: ${r} ${a}ms ease-out;
      `}

  ${({isClosingStarted:o,animationDuration:a})=>o&&t`
        animation: ${s} ${a}ms ease-out;
      `}
`,m=o.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;export{m as CloseButtonWrapper,e as ModalBoxContainer};
